export default __webpack_public_path__ + "static/media/logo-greenbb.284cbbee.png";